import router from '@/router'
import axios from 'axios'

export default {
  CANCEL_AUTH({ commit }) {
    commit('RESET_AUTH_STATE')
    localStorage.removeItem('token')
  },
  LOGOUT({ commit }) {
    commit('RESET_AUTH_STATE')
    localStorage.removeItem('token')
    sessionStorage.removeItem('isCurator')
    router.push('/')
  },
  LOGIN({ commit, state }, pin) {
    commit('SET_LOADING_VERIFY_PIN', true)
    const payload = {
      InnEmployee: state.innOrganisation,
      Pin: pin,
      Okpo: state.okpo,
      ResponsibleUserPin: state.innUser
    }
    return axios({
      method: 'POST',
      url: 'api/user/login',
      data: payload
    })
      .then(response => {
        commit('LOGIN_SUCCESS', response.data)
        commit('SET_LOADING_VERIFY_PIN', false)
        commit('CLEAR_AUTH')
      })
      .catch(error => {
        commit('LOGIN_FALSE', error.response.data)
        commit('SET_LOADING_VERIFY_PIN', false)
      })
  },
  GET_ORGANISATION_NAME({ commit, state }) {
    commit('SET_LOADING_VERIFY_ORG_NAME', true)
    let inn = state.innOrganisation
    let okpo = state.okpo
    return axios({
      method: 'GET',
      url: `/api/user/GetOrganizationName/${inn}/${okpo}`
    })
      .then(response => {
        commit('GET_ORGANISATION_NAME_SUCCESS', response.data)
        commit('SET_LOADING_VERIFY_ORG_NAME', false)
      })
      .catch(error => {
        commit('GET_ORGANISATION_NAME_ERROR', error.response.data)
        commit('SET_LOADING_VERIFY_ORG_NAME', false)
      })
  },
  GET_USER_NAME({ commit, state }) {
    commit('SET_LOADING_VERIFY_NAME', true)
    return axios({
      method: 'GET',
      url: '/api/user/GetUserName',
      params: {
        inn: state.innUser,
        isAdmin: state.isAdmin
      }
    })
      .then(response => {
        commit('GET_USER_NAME_SUCCESS', response.data)
        commit('SET_LOADING_VERIFY_NAME', false)
      })
      .catch(error => {
        commit('GET_USER_NAME_ERROR', error.response.data)
        commit('SET_LOADING_VERIFY_NAME', false)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js